import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputSwitchModule, RadioButtonModule } from 'primeng';
import { getTransportModeIcon, getTransportModeText } from '../../../utils/travel-scheduler-utils';
import { TransportIconSwitchComponent } from '../transport-icon-switch/transport-icon-switch.component';
import { VmeCommonModule } from '../../../vme-common.module';
import { TaskCollectionTravelMode } from '../../../enums/task-collection-travel-mode.enum';

@Component({
  selector: 'transport-mode-selector',
  standalone: true,
  imports: [
    CommonModule,
    InputSwitchModule,
    TransportIconSwitchComponent,
    RadioButtonModule,
    VmeCommonModule,
  ],
  templateUrl: './transport-mode-selector.component.html',
  styleUrls: ['./transport-mode-selector.component.css'],
})
export class TransportModeSelectorComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  protected availableTransportModes = [
    TaskCollectionTravelMode.Cycling,
    TaskCollectionTravelMode.Walking,
    TaskCollectionTravelMode.PublicTransport,
    TaskCollectionTravelMode.Driving,
  ];

  protected selectTransportMode(mode: TaskCollectionTravelMode) {
    if (mode == this.selectedTransportMode) {
      this.selectedTransportMode = null;
    } else {
      this.selectedTransportMode = mode;
    }

    this.transportModeSelected.emit(this.selectedTransportMode);
  }

  protected readonly getTransportModeIcon = getTransportModeIcon;
  protected readonly getTransportModeText = getTransportModeText;
  @Output() transportModeSelected = new EventEmitter<TaskCollectionTravelMode>();
  @Input() selectedTransportMode: TaskCollectionTravelMode = null;
  @Input() address: string;

  protected readonly TaskCollectionTravelMode = TaskCollectionTravelMode;
}
